import React from "react";
import { Collapse, Divider, Empty, Form, Tag } from "antd";
import dayjs from "dayjs";

const NOT_FOUND = <b style={{ color: "red" }}>ไม่พบข้อมูล</b>;

// customerTypeId: 0 = ผู้ทำสัญญา, 1, 2, ... = ผู้ค้ำประกันลำดับที่
const customerTypeLabel = (id) =>
  Number(id) === 0 ? "ผู้ทำสัญญา" : `ผู้ค้ำประกัน${id}`;

const renderStatusReply = (status) => {
  if (status === null || status === undefined) return NOT_FOUND;
  if (status === 1) return <Tag color="volcano">ตอบกลับ</Tag>;
  if (status === 2) return <Tag color="volcano">ตีกลับ</Tag>;
  if (status === 3 || status === 4)
    return <Tag color="default">ส่งถึงแล้วไม่ตอบกลับ</Tag>;
  return "-";
};

const renderItemContent = (item) => (
  <Form layout="horizontal" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
    <Form.Item label="ชื่อ" style={{ marginBottom: 4 }}>
      <b>
        {item.customerFullname} ({customerTypeLabel(item.customerTypeId)})
      </b>
    </Form.Item>
    <Form.Item label="บัญชี" style={{ marginBottom: 4 }}>
      <span>{item.contractSchema || "-"}</span>
    </Form.Item>
    <Form.Item label="EMS ไป" style={{ marginBottom: 4 }}>
      <span>{item.parcelNo || NOT_FOUND}</span>
    </Form.Item>
    <Form.Item label="EMS กลับ" style={{ marginBottom: 4 }}>
      <span>{item.parcelNoResponse || NOT_FOUND}</span>
    </Form.Item>
    <Form.Item label="สร้างเมื่อ" style={{ marginBottom: 4 }}>
      <span>
        {item.createdDate
          ? dayjs(item.createdDate).format("DD/MM/YYYY HH:mm")
          : NOT_FOUND}
      </span>
    </Form.Item>
    <Form.Item label="สถานะ" style={{ marginBottom: 4 }}>
      <span>{renderStatusReply(item.statusReply)}</span>
    </Form.Item>
    <Form.Item label="วันที่จดหมายถึงบริษัท" style={{ marginBottom: 0 }}>
      <span>
        {item.dateReply
          ? dayjs(item.dateReply).format("DD/MM/YYYY HH:mm")
          : NOT_FOUND}
      </span>
    </Form.Item>
  </Form>
);

// รวมรายการที่อยู่รอบเดียวกัน (ผู้ทำสัญญา + ผู้ค้ำ) เป็นกลุ่มเดียว เรียงตามลำดับที่ API ส่งมา
export const groupByRound = (data) => {
  const groups = new Map();
  data.forEach((item) => {
    const key = dayjs(item.roundDate).format("YYYY-MM-DD");
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(item);
  });
  return [...groups.entries()].map(([key, items]) => ({
    key,
    roundDate: items[0].roundDate,
    // ผู้ทำสัญญาก่อน แล้วตามด้วยผู้ค้ำ 1, 2, ...
    items: [...items].sort(
      (x, y) => Number(x.customerTypeId) - Number(y.customerTypeId),
    ),
  }));
};

/**
 * CheckContnoHistory
 * แสดงประวัติจดหมายบอกเลิกของสัญญา (workCancelContract จาก check-contno)
 * แบบ Collapse รอบละ 1 แถว ข้างในแสดงทุกคนในรอบนั้น
 * ต้นแบบจาก workCancelContract/modal/CheckCONTNO.js
 *
 * props:
 *  - data        : workCancelContract จาก check-contno
 *  - renderExtra : (group) => ReactNode แสดงท้ายหัวแถวของแต่ละรอบ (เช่น ปุ่มพิมพ์จดหมาย)
 */
function CheckContnoHistory({ data = [], renderExtra }) {
  if (data.length === 0) return <Empty description="ไม่พบประวัติจดหมาย" />;

  return (
    <Collapse
      style={{ textAlign: "left" }}
      items={groupByRound(data).map((group) => ({
        key: group.key,
        label: (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            <b>รอบ {dayjs(group.roundDate).format("DD/MM/YYYY")}</b>
            <span
              style={{ display: "flex", alignItems: "center", gap: "12px" }}
            >
              <span style={{ color: "#888" }}>{group.items.length} คน</span>
              {renderExtra && (
                // กันคลิกปุ่มแล้วไปพับ/กาง Collapse
                <span onClick={(e) => e.stopPropagation()}>
                  {renderExtra(group)}
                </span>
              )}
            </span>
          </div>
        ),
        children: group.items.map((item, index) => (
          <React.Fragment key={item.id}>
            {index > 0 && <Divider style={{ margin: "12px 0" }} />}
            {renderItemContent(item)}
          </React.Fragment>
        )),
      }))}
    />
  );
}

export default CheckContnoHistory;
